export default function () {
  this.route('proxyviews-best-for-index', { path: '/best-for' });
  // Registered ONLY so in-app navigations hit its redirect(), which forces a
  // full page load; the controller serves the page as server-rendered HTML
  // (the client-side renderer crashes Glimmer on this build). See
  // routes/proxyviews-best-for.js and app/controllers/best_for_controller.rb.
  this.route('proxyviews-best-for', { path: '/best-for/:use_case' });
  this.route('proxyviews-guides', { path: '/guides' });
  this.route('proxyviews-guide', { path: '/guides/:slug' });
  // Comparison pages — the slug is the full "<a>-vs-<b>" string; the Rails
  // route /compare/:slug_a-vs-:slug_b parses it server-side, and the Ember
  // route passes the whole slug through to the JSON fetch.
  this.route('proxyviews-comparison', { path: '/compare/:comparison_slug' });
  this.route('proxyviews-alternatives', { path: '/alternatives/:slug' });
  this.route('proxyviews-geo', { path: '/proxies/:country' });
  this.route('proxyviews-geo-city', { path: '/proxies/:country/:city' });
  this.route('proxyviews-glossary', { path: '/glossary' });
  this.route('proxyviews-glossary-term', { path: '/glossary/:slug' });

  // Admin CRUD for guides/comparisons — this plugin previously had no admin
  // UI at all; content only existed via seed files.
  this.route('adminPlugins', { path: '/admin/plugins' }, function () {
    this.route('proxyviews-seo', { path: '/proxyviews-seo' });
  });
}
